<template>
  <div class="tableStatusTag whiteSpaceNowrap" :class="tag">
    <p>
      <template v-if="label == 'time-limit'">
        <template v-if="time.days != 0">
          {{ parseInt(time.days) }} Day(s)
        </template>
        <template v-else>
          {{ time.hours.charAt(0) }}{{ time.hours.charAt(1) }} :
          {{ time.minutes.charAt(0) }}{{ time.minutes.charAt(1) }} :
          {{ time.seconds.charAt(0) }}{{ time.seconds.charAt(1) }}
        </template>
      </template>
      <template v-else-if="label == 'starts-in'">
        Starts in {{ time.diff }}
      </template>
      <template v-else-if="label == 'due-in'"> Due in {{ time.diff }} </template>
      <template v-else>
        {{ label }}
      </template>
    </p>
  </div>
</template>
<script>
export default {
  props: ["test", "role", "testStatus"],
  data() {
    return {
      timer: "",
      time: {
        days: 0,
        hours: "00",
        minutes: "00",
        seconds: "00",
        diff: "",
      },
      label: "",
      tag: "",
    };
  },
  created() {
    if (this.role == "topBarStatus") {
      this.processStudentTopBarStatus();
    } else if (this.role == "testView") {
      this.processStudentTestStatus();
    } else if (this.role != "student") { 
      this.processTeacherStatusDisplay();
    } else {
      this.processStudentStatusDisplay();
    }
  },
  methods: {
    processTeacherStatusDisplay() {
      this.stopTimer();
      if (!this.test) {
        this.label = "Draft";
      }
      if (_.get(this.test, "settings.type") == "synchronous") {
        if (_.get(this.test, "status") == "not started") {
          this.label = "Not Started";
        } else if (_.get(this.test, "status") == "ongoing") {
          if (!_.get(this.test, "settings.hasTimeLimit")) {
            this.label = "Opened";
          } else {
            //hasTimeLimit
            this.label = "time-limit";
            this.initTimer();
          }
        } else if (_.get(this.test, "status") == "paused") {
          this.label = "Paused";
        } else if (
          ["ended", "completed"].includes(_.get(this.test, "status"))
        ) {
          this.label = "Closed";
        }
      } else if (_.get(this.test, "settings.type") == "asynchronous") {
        if (_.get(this.test, "status") == "scheduled") {
          this.label = "starts-in";
          this.initTimer();
        } else if (_.get(this.test, "status") == "ongoing") {
          this.label = "Opened";
        } else if (
          ["ended", "completed"].includes(_.get(this.test, "status"))
        ) {
          this.label = "Closed";
        }
      }
      this.tag = this.label;
      if (this.label == "Not Started" || this.label == "Draft" || this.label == "Closed") {
        this.tag = "tableStatusTag-dark";
      } else if (this.label == "Opened") {
        this.tag = "tableStatusTag-primary";
      } else if (this.label == "Paused") {
        this.tag = "tableStatusTag-warning";
      }
    },
    processStudentStatusDisplay() {
      this.stopTimer();
      /*if( _.get(this.test, "testStudent.myProgression.userTestStatus") ==
          "ongoing" && ["ended", "completed"].includes(_.get(this.test, "status")))
      {
        this.test.testStudent.myProgression.userTestStatus = 'Incomplete'
        //missed case
      }*/
      if (_.get(this.test, "settings.type") == "synchronous") {
        if (_.get(this.test, "status") == "not started") {
          this.label = "Not Started";
        } else if (
          _.get(this.test, "testStudent.myProgression.userTestStatus") ==
          "finished"
        ) {
          this.label = "Finished";
        } else if (
          _.get(this.test, "testStudent.myProgression.userTestStatus") ==
          "incomplete"
        ) {
          this.label = "Incomplete";
        } else if (_.get(this.test, "status") == "ongoing") {
          if (!_.get(this.test, "settings.hasTimeLimit")) {
            this.label = "Opened";
          } else {
            //hasTimeLimit
            this.label = "time-limit";
            this.initTimer();
          }
        } else if (_.get(this.test, "status") == "paused") {
          this.label = "Paused";
        } else if (
          ["ended", "completed"].includes(_.get(this.test, "status"))
        ) {
          this.label = "Missed";
        }
      } else if (_.get(this.test, "settings.type") == "asynchronous") {
        if (_.get(this.test, "status") == "scheduled") {
          this.label = "starts-in";
          this.initTimer();
        } else if (
          _.get(this.test, "testStudent.myProgression.userTestStatus") ==
          "finished"
        ) {
          this.label = "Finished";
        } else if (
          _.get(this.test, "testStudent.myProgression.userTestStatus") ==
          "incomplete"
        ) {
          this.label = "Incomplete";
        } else if (_.get(this.test, "status") == "ongoing") {
          if (
            _.get(this.test, "testStudent.myProgression.userTestStatus") ==
            "started"
          ) {
            if (_.get(this.test, "settings.hasTimeLimit")) {
              this.label = "time-limit";
              this.initTimer();
            } else {
              this.label = "due-in";
              this.initTimer();
            }
          } else {
            this.label = "due-in";
            this.initTimer();
          }
        } else if (
          ["ended", "completed"].includes(_.get(this.test, "status"))
        ) {
          if (this.test.type == "prework") {
            this.label = "Closed";
          } else {
            this.label = "Missed";
          }
        }
      }

      this.tag = this.label;
      if (this.label == "Not Started" || this.label == "Draft" || this.label == "Closed") {
        this.tag = "tableStatusTag-dark";
      } else if (this.label == "Opened") {
        this.tag = "tableStatusTag-primary";
      } else if (this.label == "Paused") {
        this.tag = "tableStatusTag-warning";
      } else if (this.label == "Finished") {
        this.tag = "tableStatusTag-success";
      } else if (this.label == "Missed" || this.label == "Incomplete") {
        this.tag = "tableStatusTag-danger";
      }
    },
    processStudentTestStatus() {
      if (this.testStatus == -1) {
        this.label = 'Wrong Answer';
        this.tag = 'danger';
      } else if (this.testStatus == 0) {
        this.label = 'Not Answered';
        this.tag = 'danger';
      } else if (this.testStatus == 1) {
        this.label = 'Answered';
        this.tag = 'default';
      }
    },
    processStudentTopBarStatus() {
      if (this.test == 'not started') {
        this.label = 'Not Started';
        this.tag = 'tableStatusTag-danger';
      } else if (this.test == 'paused') {
        this.label = 'Paused';
        this.tag = 'tableStatusTag-warning';
      } else if (this.test == 'ongoing') {
        this.label = 'Ongoing';
        this.tag = 'tableStatusTag-warning';
      } else if (['ended', 'completed'].includes(this.test)) {
        this.label = 'Ended';
        this.tag = 'tableStatusTag-danger';
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    async initTimer() {
      var that = this;

      let a = _.get(
        this.test,
        "myProgression.startTime",
        _.get(
          this.test,
          "settings.startTime",
          _.get(this.test, "startTime", _.get(this.test, "settings.startDate"))
        )
      );

      let b = _.get(
        this.test,
        "myProgression.endTime",
        _.get(
          this.test,
          "settings.endTime",
          _.get(this.test, "endTime", _.get(this.test, "settings.endDate"))
        )
      );
      if (!(a && b)) {
        return;
      }
      //sync or async uses same time.
      var startTime = this.convertToReadableDate(a).dateObj;
      var endTime = this.convertToReadableDate(b).dateObj;
      this.stopTimer();
      this.timer = setInterval(function() {
        var now = moment();
        var distance = moment.duration(endTime.diff(now));
        var startTimeDuration = moment.duration(startTime.diff(now));
        let daysFromNow = Math.floor(distance.asDays());
        let daysFromStart = Math.floor(startTimeDuration.asDays());
        if (distance > 0) {
          that.time.days = daysFromNow;
          that.time.hours = ("0" + distance.hours()).slice(-2);
          that.time.minutes = ("0" + distance.minutes()).slice(-2);
          that.time.seconds = ("0" + distance.seconds()).slice(-2);
        } else {
          that.time.days = 0;
          that.time.hours = "00";
          that.time.minutes = "00";
          that.time.seconds = "00";
          that.stopTimer();
        }

        //totalDistance.subtract(1,'seconds');

        if (that.test.settings.type == "synchronous") {
          const percentile =
            (100.0 * now.diff(startTime)) / endTime.diff(startTime);

          if (percentile >= 80.0) {
            that.tag = "tableStatusTag-danger";
          } else if (percentile >= 50.0) {
            that.tag = "tableStatusTag-warning";
          } else if (percentile >= 0) {
            that.tag = "tableStatusTag-primary";
          }
        } else {
          if (that.label == "starts-in") {
            if (daysFromStart != 0) {
              that.time.diff = daysFromStart + " Day(s) ";
            } else {
              that.time.diff =
                ("0" + startTimeDuration.hours()).slice(-2) +
                " : " +
                ("0" + startTimeDuration.minutes()).slice(-2) +
                " : " +
                ("0" + startTimeDuration.seconds()).slice(-2);
            }
            if (startTimeDuration.hours() == 0 && daysFromStart == 0) {
              that.tag = "tableStatusTag-danger";
            } else if (startTimeDuration.hours() != 0 && daysFromStart == 0) {
              that.tag = "tableStatusTag-warning";
            } else if (startTimeDuration.hours() != 0 && daysFromStart != 0) {
              that.tag = "tableStatusTag-primary";
            }
          } else if (that.label == "due-in") {
            if (daysFromNow != 0) {
              that.time.diff = daysFromNow + " Day(s) ";
              //that.time.diff = ("0" + distance.days()).slice(-2) + " Day(s) ";
            } else {
              that.time.diff =
                ("0" + distance.hours()).slice(-2) +
                " : " +
                ("0" + distance.minutes()).slice(-2) +
                " : " +
                ("0" + distance.seconds()).slice(-2);
            }

            const percentile =
              (100.0 * now.diff(startTime)) / endTime.diff(startTime);

            if (percentile >= 80.0) {
              that.tag = "tableStatusTag-danger";
            } else if (percentile >= 50.0) {
              that.tag = "tableStatusTag-warning";
            } else if (percentile >= 0) {
              that.tag = "tableStatusTag-primary";
            }
          } else {
            const percentile =
              (100.0 * now.diff(startTime)) / endTime.diff(startTime);

            if (percentile >= 80.0) {
              that.tag = "tableStatusTag-danger";
            } else if (percentile >= 50.0) {
              that.tag = "tableStatusTag-warning";
            } else if (percentile >= 0) {
              that.tag = "tableStatusTag-primary";
            }
          }
        }
      }, 1000);
    },
  },
  watch: {
    test: {
      handler: function () {
        if (this.role == "topBarStatus") {
          this.processStudentTopBarStatus();
        } else if (this.role == "testView") {
          this.processStudentTestStatus();
        } else if (this.role != "student") { 
          this.processTeacherStatusDisplay();
        } else {
          this.processStudentStatusDisplay();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.tableStatusTag {
  // font-weight: bold;
  text-align: center;
  padding: 6px 8px;
  border-radius: 44px;
  background-color:#fff;
  // height:36px;
  // line-height: 1.3;
  font-size: 0.88rem;
  line-height: 0.8;

  p {
    font-size: 0.88rem;
    display: inline-block;
  }

  &.tableStatusTag-dark,
  &.Starts {
    // border: 1px solid #767676;
    // background-color: #EFEFEF;
    // color: #767676;
    background: #EFEFEF;
    border: 1px solid #767676;
    color: #3C3C43;
  }

  &.tableStatusTag-primary {
    // border: 1px solid #0071EB;
    // background-color: #FFF;
    // color: #0071EB;
    background: #93C4F9;
    border: 1px solid #0071EB;
    color: #3C3C43;
  }

  &.tableStatusTag-warning {
    // border: 1px solid #C97420;
    // background-color: #FFF;
    // color: #C97420;
    background: #E3C1A0;
    border: 1px solid #AC631B;
    color: #3C3C43;
  }

  &.tableStatusTag-success {
    // border: 1px solid #2D8659;
    // background-color: #FFF;
    // color: #2D8659;
    background: #A5C9B7;
    border: 1px solid #2D8659;
    color: #3C3C43;
  }

  &.tableStatusTag-danger {
    // border: 1px solid #D04343;
    // background-color: #FFF;
    // color: #D04343;
    background: #E6AEAE;
    border: 1px solid #D04343;
    color: #3C3C43;
  }

  &.danger {
    border: 1px solid #D04343;
    background:#D04343;
    color: #fff;
    // font-weight: normal;
  }

  &.default {
    border: 1px solid #EFEFEF;
    background:#EFEFEF;
    color: #767676;
    // font-weight: normal;
  }

  &.answered {
    border: 1px solid #E4EFE9;
    background: #E4EFE9;
    color: #767676;
  }
}

.testSidebar-status {
  font-size: 0.667rem;
  line-height: 1;
  padding: 6px 12px;

  p {
    font-size: 0.667rem;
    line-height: 1;
  }

  &.danger {
    padding: 6px 8px;
  }
}
</style>
